import { useState } from 'react';
import { useI18n } from '../lib/i18n';
import { THEMES, readTheme, saveTheme, type Theme } from '../lib/theme';

/** Mavzu almashtirgich: tizim / yorug' / qorong'i. */
export function ThemeSwitch() {
  const { t } = useI18n();
  const [theme, setTheme] = useState<Theme>(() => readTheme());

  const icon: Record<Theme, string> = { system: '◐', light: '☀', dark: '☾' };

  return (
    <div className="segmented segmented--sm" role="radiogroup" aria-label={t('theme.aria')}>
      {THEMES.map((code) => (
        <button
          key={code}
          type="button"
          role="radio"
          aria-checked={theme === code}
          title={t(`theme.${code}`)}
          className={`segmented__btn ${theme === code ? 'is-active' : ''}`}
          onClick={() => {
            saveTheme(code);
            setTheme(code);
          }}
        >
          <span aria-hidden="true">{icon[code]}</span>
        </button>
      ))}
    </div>
  );
}
